import React                 from 'react';
import merge                 from 'deepmerge';
import { isNullOrUndefined } from 'rewire-common';
import { Observe }           from 'rewire-core';
import {
  Dialog
  as
  RewireDialog,
  DialogProps
  as
  RewireDialogProps,
  IDialogProps,
}                            from 'rewire-ui';
import {
  MuiThemeProvider,
  Theme
}                            from '@material-ui/core/styles';
import { withStyles }        from '../utility/styles';
import './dialog.css';

export const dialog2Theme = (outerTheme: Theme) => ({
  ...outerTheme,
  palette: merge(outerTheme.palette, {
    primary: {
      light: outerTheme.palette.dialogPrimary.light,
      main: outerTheme.palette.dialogPrimary.main,
      dark: outerTheme.palette.dialogPrimary.dark,
      contrastText: outerTheme.palette.dialogPrimary.contrastText,
    },
  }),
  overrides: merge(outerTheme.overrides!, {
    MuiDialog: {
      paperWidthXs: {
        maxWidth: '400px',
      },
    },
    MuiButton: {
      textPrimary: {
        color: outerTheme.palette.dialogPrimary.contrastText,
        textTransform: 'uppercase',
      },
      contained: {
        textTransform: 'uppercase',
        minWidth: '90px',
        backgroundColor: outerTheme.palette.dialogPrimary.main,
        color: outerTheme.palette.dialogPrimary.contrastText,
        fontWeight: 'normal',
        '&:hover:not($disabled)': {
          backgroundColor: outerTheme.palette.dialogPrimary.light,
        },
      },
      text: {
        textTransform: 'uppercase',
      }
    },
  }),
} as Theme);

export const dialog2Styles = (_theme: Theme) => ({
  root: {
    borderRadius: '5px',
  },
  heading: {
    justifyContent: 'center',
    '& > hr': {
      marginTop: '10px',
    },
  },
  buttons: {
    margin: '20px 0px',
    '& > *': {
      marginLeft: '0px',
      marginRight: '15px',
    },
  },
  divider: {
  },
  childrenContainer: {
  },
});

class Dialog2 extends React.Component<RewireDialogProps> {
  render() {
    const {classes, children, disableEscapeKeyDown, dialog, ...restProps} = this.props;

    return <Observe render={() => (
      <MuiThemeProvider theme={dialog2Theme}>
        <RewireDialog dialog={dialog} classes={classes} buttonVariant={'contained'} disableEscapeKeyDown={!isNullOrUndefined(disableEscapeKeyDown) ? disableEscapeKeyDown : true} {...restProps}>
          {children}
        </RewireDialog>
      </MuiThemeProvider>
    )} />;
  }
}

export default withStyles<IDialogProps>(dialog2Styles, Dialog2);
